import { tokenManager } from "services/client/token-manager";
import { roles } from "shared/constants/Constants";

/** Roles allowed to open `/desk` (portal picker) and see it in the profile menu. */
export const DESK_RBAC = [
  roles.ADMIN,
  roles.ONBOARDING,
  roles.TELECALLING,
  roles.HUB_MANAGER,
  roles.DRIVER_MANAGER,
  roles.TELECALLER_LEAD,
  roles.SUPER_ADMIN,
  roles.FINANCE,
];
export const OPS_RBAC = [roles.SUPER_ADMIN, roles.ADMIN, roles.FINANCE];

function normalizeRoleList(roleList) {
  return Array.isArray(roleList) ? roleList : roleList != null && roleList !== "" ? [roleList] : [];
}

function userHasAnyRole(roleList, allowedRoles) {
  const list = normalizeRoleList(roleList);
  if (list.length === 0) return false;
  return list.some((r) => r != null && r !== "" && allowedRoles.includes(String(r)));
}

/**
 * @param {unknown} roleList - e.g. Redux `state.role.roles`
 */
export function userCanAccessDeskPortal(roleList) {
  // return userHasAnyRole(roleList, DESK_RBAC);
  return true;
}

/**
 * Portal picker after login. Used by Login redirect and /desk route.
 *
 * External portals can send users back with an explanation when sign-on fails, e.g.:
 *   /desk?message=SSO%20session%20expired
 * Query param: `message` (any URL-encoded plain text).
 */
export const SHOW_PORTAL_SELECTION_MODAL =
  process.env.REACT_APP_SHOW_PORTAL_SELECTION_MODAL === "true";

export function showTLDashboard(roleList) {
  const tlRBAC = [roles.ADMIN, roles.TELECALLER_LEAD];
  return userHasAnyRole(roleList, tlRBAC);
}

export const PORTAL_OPTIONS = [
  { id: "carrum", label: "Portal", path: "/", isAbsolute: false },
  {
    id: "ops",
    label: "OPS",
    path: process.env.REACT_APP_OPS_URL,
    isAbsolute: true,
    // appendAuthTokensQuery: true,
    comingSoon: true,
  },
  {
    id: "crm",
    label: "ERP",
    path: process.env.REACT_APP_CRM_URL,
    isAbsolute: true,
    requiresFrappeCredentials: true,
    sso_usr: "",
    sso_pwd: "",
  },
  {
    id: "TL dashboard",
    label: "TL Dash",
    path: process.env.REACT_APP_ANALYTICS_DASHBOARD_URL,
    isAbsolute: true,
    requiresFrappeCredentials: false,
  },
];

export function hasFrappeCredentials() {
  const { username, password } = tokenManager.getFrappeCredentials();
  return Boolean(username && password);
}

export function getAvailablePortalOptions(roleList, hasApiFrappeCredentials = false) {
  const canOpenErp = hasFrappeCredentials() || hasApiFrappeCredentials;
  const canOpenOps = userHasAnyRole(roleList, OPS_RBAC);
  const canOpenTLDashboard = showTLDashboard(roleList);
  const availablePortals = PORTAL_OPTIONS.filter((portal) => {
    if (portal.id === "TL dashboard") {
      return canOpenTLDashboard && !!process.env.REACT_APP_ANALYTICS_DASHBOARD_URL;
    }
    return !portal.requiresFrappeCredentials || canOpenErp;
  }).map((portal) =>
    portal.id === "ops"
      ? {
          ...portal,
          comingSoon: !canOpenOps,
        }
      : portal
  );
  return availablePortals;
}

/**
 * Builds absolute redirect URL, optionally appending session tokens for SSO targets (avoid logging/sharing URLs).
 */
export function buildAbsolutePortalUrl(portal) {
  const base = portal.path || "/";
  if (!portal.appendAuthTokensQuery) {
    return base;
  }
  let url;
  try {
    url = new URL(base);
  } catch {
    return base;
  }
  return url.toString();
}

export function goToPortal(portal, { navigate }) {
  const path = portal.path || "/";
  if (portal.isAbsolute) {
    window.location.assign(buildAbsolutePortalUrl(portal));
  } else {
    navigate(path);
  }
}
